import "../../css/fonts.css";
import "../../css/container.css";
import "../../css/about.css";

import { ContainerNoBg } from "../../components/container.no.bg";
import { Clickable } from "../../components/clickable.container";
import { CenteredImageStrip } from "../../components/image.strip";
import { useIsMobile } from "../../hooks/is.mobile";
import { ImportAll, shuffleArray } from "../../utils/utils";

const imagesArt = ImportAll(
  require.context("../../assets/3dArt", false, /\.(png|jpe?g|svg)$/)
);

const imagesGamedev = ImportAll(
  require.context("../../assets/Gamedev", false, /\.(png|jpe?g|svg)$/)
);

const combined = [...imagesArt, ...imagesGamedev];
const images = shuffleArray(combined).slice(0, 3);

const imagesTeam = ImportAll(
  require.context("../../assets/team", false, /\.(png|jpe?g|svg)$/)
);

export const AboutPC = () => {
  const isMobile = useIsMobile();
  return (
    <div>
      <ContainerNoBg>
        <div className={"about-title"}></div>
        <div
          style={{
            paddingLeft: isMobile ? "10vw" : "4.5vw",
            paddingRight: isMobile ? "10vw" : "0",
            paddingTop: isMobile ? "8vw" : "2vw",
            fontSize: isMobile ? "5vw" : "3vw",
          }}
          className={"title-text-font" + " " + "text-align"}
        >
          TOGETHER, WE BUILD WORLDS
        </div>
        <div
          style={{
            paddingLeft: isMobile ? "10vw" : "4.5vw",
            paddingRight: isMobile ? "10vw" : "4.5vw",
            paddingTop: isMobile ? "6vw" : "2.5vw",
            paddingBottom: isMobile ? "6vw" : "2vw",
            fontSize: isMobile ? "4vw" : "1.75vw",
          }}
        >
          We’re a tight-knit team of game developers, artists, and storytellers
          committed to crafting high-quality, unforgettable experiences. We take
          our work seriously, from concept to code, every project is built with
          precision, passion, and just enough caffeine to power a small
          spaceship. At the core, it’s about creating worlds that players love
          to explore and having a damn good time doing it.
        </div>
      </ContainerNoBg>
      <ContainerNoBg>
        <div style={{ paddingTop: "2vw" }}>
          <CenteredImageStrip images={images} />
        </div>
      </ContainerNoBg>
      <ContainerNoBg>
        <div
          style={{
            paddingLeft: "4.5vw",
            paddingTop: isMobile ? "12vw" : "6vw",
            fontSize: isMobile ? "5vw" : "3vw",
          }}
          className={"title-text-font" + " " + "text-align"}
        >
          THE TEAM
        </div>
        <div className="three-column-container">
          <Clickable
            onclick={() => {}}
            children={<div className="team-member-box-text">Nenad Popović</div>}
            style="team-member-box"
            backgroundUrl={imagesTeam[0]}
          />
          <Clickable
            onclick={() => {}}
            children={
              <div className="team-member-box-text">Leonard Svilan</div>
            }
            style="team-member-box"
            backgroundUrl={imagesTeam[1]}
          />
          <Clickable
            onclick={() => {}}
            children={
              <div className="team-member-box-text">Domagoj Volarević</div>
            }
            style="team-member-box"
            backgroundUrl={imagesTeam[2]}
          />
        </div>
      </ContainerNoBg>
    </div>
  );
};
